import React from "react";

import roku from "../../../resources/roku.png";

import type { JSX } from "react";

interface IRokuIcon {
  className?: string;
}

function RokuIcon(props: IRokuIcon): JSX.Element {
  const { className } = props;
  return <img alt="roku-icon" className={className} src={roku} />;
}

export default RokuIcon;
